/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { requestSubscription, graphql } from 'react-relay';

import { ConnectionHandler } from 'relay-runtime';

import environment from '../RelayEnv';

const subscription = graphql`
  subscription ReplySentSubscription {
    replySent {
      node {
        id
        ...Reply_reply
        message {
          id
        }
      }
    }
  }
`;

const subscribe = function(viewer, options) {
  if (options == null) {
    options = {};
  }
  return requestSubscription(environment, {
    subscription,
    variables: {},
    updater: store => {
      const payload = store.getRootField('replySent');
      const node = payload.getLinkedRecord('node');
      const replyId = node.getValue('id');

      const message = node.getLinkedRecord('message');
      const messageProxy = store.get(message.getValue('id'));
      if (messageProxy != null) {
        const conn = ConnectionHandler.getConnection(
          messageProxy,
          'Replies_replies',
        );
        if (conn != null) {
          // Check if reply already exists in the connection
          const edges = conn.getLinkedRecords('edges');
          const alreadyExists =
            edges &&
            edges.some(edge => {
              const edgeNode = edge && edge.getLinkedRecord('node');
              return edgeNode && edgeNode.getValue('id') === replyId;
            });

          if (alreadyExists) {
            console.log('Reply already in connection, skipping:', replyId);
            return;
          }

          const newEdge = ConnectionHandler.createEdge(
            store,
            conn,
            node,
            'ReplyEdge',
          );
          return ConnectionHandler.insertEdgeAfter(conn, newEdge);
        }
      }
    },
    ...options,
  });
};

export default { subscribe };
